import * as httpUtil from "@/utils/httpUtil";
const interfaces: Array<Record<string, any>> = [
  {
    //desc: "社区列表表",
    method: "post",
    name: "pagePersonalCommunity",
    url: "/v2/community/pagePersonalCommunity",
    config: { ignoreError: true },
  },
  {
    //desc: "分页列出个人的所有社区类型数量",
    method: "get",
    name: "pagePersonalCommunityCount",
    url: "/v2/community/pagePersonalCommunityCount",
  },
  {
    //desc: "创建社区",
    method: "post",
    name: "createCommunity",
    url: "/v2/community/save",
  },
  {
    //desc: "检查健康社区名称是否重复",
    method: "post",
    name: "checkCommunityNameRepeat",
    url: "/v2/hc/checkCommunityName",
    config: { ignoreError: true },
  },
  {
    //desc: "健康社区添加备注",
    method: "post",
    name: "addCommunityRemark",
    url: "/v2/community/addCommunityRemark",
    // config: { ignoreError: true },
  },
  {
    //desc: "首页装修",
    method: "post",
    name: "fitmentIndex",
    url: "/medicine/fitment/index",
  },
  {
    //desc: "保存社区装修",
    method: "post",
    name: "fitmentSaveModule",
    url: "/medicine/fitment/saveModule",
    config: { ignoreError: true },
  },
  {
    //desc: "删除模块配置",
    method: "post",
    name: "fitmentDeleteModule",
    url: "/medicine/fitment/deleteModule",
    // config: { ignoreError: true },
  },
  {
    //desc: "查询健康首页上下架配置",
    method: "post",
    name: "getHomePageConfig",
    url: "/c/pc/homePage/hc/getConfig",
  },
  {
    //desc: "编辑健康首页上下架配置",
    method: "post",
    name: "updateHomePageConfig",
    url: "/c/pc/homePage/hc/updateConfig",
  },
  {
    //desc: "查询社区门店信息",
    method: "post",
    name: "getShopDetail",
    url: "/c/h5/shop/detail",
  },
  {
    //desc: "查询全部行业领域",
    method: "post",
    name: "industryListAll",
    url: "/c/pc/industry/listAll",
  },
  {
    //desc: "获取配置开关信息",
    method: "post",
    name: "getOpenStatusByApplicationConfig",
    url: "/medicine/fitment/getOpenStatusByApplicationConfig",
  },
  {
    //desc: "查询社区门店信息",
    method: "post",
    name: "findCommunityCertificationProgressList",
    url: "/c/h5/community/findCommunityCertificationProgressList",
  },
  {
    //desc: "获取社区服务套餐信息",
    method: "post",
    name: "getCommunityServicePackage",
    url: "/h5/service/order/getCommunityServicePackage",
  },
  {
    //desc: "生成小程序二维码",
    method: "post",
    name: "createCommunityChannelMiniProgramQRCode",
    url: "/c/admin/community/channelLink/createMiniProgramQRCode",
  },
  {
    //desc: "获取社区当前未支付的预购订单(创建订单)",
    method: "post",
    name: "findUnPayOrder",
    url: "/h5/service/order/findUnPayOrder",
  },
  {
    //desc: "创建预购订单",
    method: "post",
    name: "createServiceOrder",
    url: "/h5/service/order/createServiceOrder",
    config: { ignoreError: true },
  },
  {
    //desc: "获取订单详情",
    method: "post",
    name: "findOrderDetail",
    url: "/h5/service/order/findOrderDetail",
  },
  {
    //desc: "获取用户信息",
    method: "get",
    name: "getUserInfo",
    url: "/login/myInfo",
  },
  {
    //desc: "分页查询采购单",
    method: "post",
    name: "findCommunityServiceOrderPage",
    url: "/service/order/manager/findCommunityServiceOrderPage",
  },
  {
    //desc: "通过业务id获取订单详情",
    method: "post",
    name: "findDetailByIdB2D2C",
    url: "/service/order/manager/findDetailById",
  },
  {
    //desc: "渠道ID查询渠道链接",
    method: "get",
    name: "channelLinkFindById",
    url: "/c/pc/community/channelLink/findById",
  },
  {
    //desc: "获取社区访问令牌",
    method: "post",
    name: "findCommunityAccessToken",
    url: "/c/pc/security/findCommunityAccessToken",
  },
  {
    //desc: "社区首页批量修改装修模板设置的排序值",
    method: "post",
    name: "batchUpdateSettingSort",
    url: "/medicine/fitment/batchUpdateSettingSort",
  },
];

function exportsRender(interfacesArr: Array<Record<string, any>>) {
  const resultExports: Record<string, any> = {};
  interfacesArr.map((item: Record<string, any>) => {
    resultExports[item.name] = (data: Record<string | number, any>) => {
      return (httpUtil as Record<string, any>)[item.method](item.url, data, item.config);
    };
  });
  return resultExports;
}

export default exportsRender(interfaces);
